/**
 * HealthMonitorIcon — A pulse in a frame: the health of the system. Hugeicons activity-03 (MIT).
 */

import svg from './svg/health-monitor.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const HealthMonitorIcon = makeSvgIcon('health-monitor', svg);
